<template>
  <div>
    <div class="clickable-div" data-toggle="modal" data-target="#intro-video">
      <div class="clickable-div__overlay">
      </div>
      <img :src="video.image" :alt="`${video.title} video thumbnail`" class="thumbnail">
      <span class="play-icon"></span>
    </div>
    <Modal idModal="intro-video">
      <Media :src="video.src" :data-gtm-section="video.title" data-gtm-label="Play video" />
    </Modal>
  </div>
</template>

<script>

import Modal from '@/components/modal/Modal.vue';
import Media from '@/components/ui/Media.vue';

export default {
  name: 'CustomerTestimonials',
  components: {
    Modal,
    Media,
  },
  data() {
    return {
      video: {
        title: '',
        src: 'https://www.youtube.com/watch?v=Ke6RlEMoFsQ',
        image: 'images/why-digital/manufacturing-benefits/BatchCorrugation_Thumbnail.png',
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/_mixins.scss';
@import '@/scss/views/why-digital/customers/testimonials';

.clickable-div {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1012px;
  margin: auto;

  .clickable-div__overlay {
    background-color: #0000004D;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 5;
    cursor: pointer;
  }
  .thumbnail {
    width: 100%;
  }
}

.play-icon {
  top: 50%;
  background-image: url($alter-play-icon);
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  width: 100%;
  height: 100%;
  z-index: 6;
  border: 0;
}

.clickable-div:hover .thumbnail {
  transform: scale(1);
}

.clickable-div:hover .play-icon {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1.1);
}
</style>
